import { TransactionForm } from "../model/transaction-form.model";

export class FormController {
  $onInit() {
    this.transactionForm = new TransactionForm(this.customerProducts);
  }

  $doCheck() {
    if (this.transactionForm && this.paymentOption) {
      this.transactionForm.paymentOptionType = this.paymentOption.type;
    }
  }

  submit() {
    
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit2/component/form.controller.js